import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { KioskDashboardQueryKeys } from "modules/KioskDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Kiosk } from "models";

export const useUpdateKioskMutation = () =>
  useTypedMutation<Kiosk, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/dashboard/update", payload, ENV.kioskBaseURL);
    },
    onSuccess: payload => {
      const kiosks = typedQueryClient.getQueryData(KioskDashboardQueryKeys.kiosks);
      if (!kiosks) return;

      const kioskIdx = kiosks.findIndex(kiosk => kiosk.id === payload.id);
      if (kioskIdx === -1) return;

      typedQueryClient.setQueryData(KioskDashboardQueryKeys.kiosks, kiosks.with(kioskIdx, payload));
    }
  });
